import React from 'react';
import { Jumbotron } from 'react-bootstrap';

const TitleModule = ({ text }) => {
  return (
    <Jumbotron className="Jumbotron">
      <h3>{text}</h3>
    </Jumbotron>
  );
};

export default TitleModule;


// WEBPACK FOOTER //
// ./src/components/widgets/module_title.jsx